module.exports = require("@trendmicro/react-anchor");


//////////////////
// WEBPACK FOOTER
// external "@trendmicro/react-anchor"
// module id = 6
// module chunks = 0